import _ from "lodash";
import { NotificationManager } from "react-notifications";
import { Types } from "../actions/leaveActions";

import cleanDeep from "clean-deep";
import {
	addDays,
	addHours,
	differenceInCalendarDays,
	differenceInCalendarISOWeeks,
	differenceInMinutes,
	format,
	getDay,
	parse,
	startOfWeek,
	subDays,
} from "date-fns";
import { sumBy, set } from "lodash";
import { v4 as uuidv4 } from "uuid";

const defaultState = {
	leave: {
		leaveBalancesByType: undefined,
	},
};

const leaveReducers = (state = defaultState, action) => {
	switch (action.type) {
		case Types.LEAVE_CARRYOVER_MAX: {
			let newState = _.cloneDeep(state);

			const maxValues = {
				maxCarryover: action.maxCarryover,
				maxPayable: action.maxPayable,
				carryoverAll: action.carryoverAll,
			};

			newState.leave = {
				...newState.leave,
				leaveCarryoverMax: maxValues,
			};

			return newState;
		}

		case Types.LEAVE_UPDATE_SINGULAR_BALANCE: {
			let newState = _.cloneDeep(state);

			const vacation = action.response.leaveBalancesByType["6020"];
			const sick = action.response.leaveBalancesByType["6022"];

			if (newState.leave.leaveBalancesByType != undefined) {
				const vacationBalances = newState.leave.leaveBalancesByType["6020"].filter(
					(item) => item.agreementId != vacation.agreementId,
				);
				const sickBalances = newState.leave.leaveBalancesByType["6022"].filter(
					(item) => item.agreementId != sick.agreementId,
				);

				newState.leave = {
					...newState.leave,
					leaveBalancesByType: {
						["6020"]: [...vacationBalances, vacation],
						["6022"]: [...sickBalances, sick],
					},
				};
			} else {
				newState.leave = {
					...newState.leave,
					leaveBalancesByType: {
						["6020"]: [vacation],
						["6022"]: [sick],
					},
				};
			}

			return newState;
		}

		case Types.LEAVE_CARRYOVER_MODAL: {
			let newState = _.cloneDeep(state);

			newState.leave = {
				...newState.leave,
				leaveCarryoverModal: action.status,
			};

			return newState;
		}

		case Types.LEAVE_DETAILED_REPORT_DOWNLOADING: {
			let newState = _.cloneDeep(state);

			// newState.leave.modalLeave = {...newState.leave.modalLeave};
			newState.leave.detailedReportDownloading = action.status;

			return newState;
		}
		case Types.LEAVE_BREAKDOWN_STATUS: {
			let newState = _.cloneDeep(state);

			newState.leave.modalLeave.hoursBreakdownProcessing = action.processing;
			return newState;
		}
		case Types.LEAVE_BREAKDOWN: {
			let newState = _.cloneDeep(state);

			// newState.leave.modalLeave = {...newState.leave.modalLeave};
			newState.leave.modalLeave.hoursBreakdown = {};

			action.payload.map((i) => {
				newState.leave.modalLeave.hoursBreakdown[i.date] = { ...i, edited: true };
			});
			newState.leave.modalLeave.hours = sumBy(action.payload, "hours");
			newState.leave.modalLeave.hoursBreakdownProcessing = false;

			return newState;
		}
		case Types.LEAVE_CARRYOVER_STATUS: {
			console.log("LEAVE_CARRYOVER_STATUS open");

			let newState = _.cloneDeep(state);

			newState.leave.carryoverProcessing = action.processing;

			if (!action.processing && newState.organisation) {
				// TODO update organisation
				newState.organisation.carryover = {
					year: new Date().getFullYear(),
				};
			}

			return newState;
		}
		case Types.LEAVE_TAB: {
			let newState = _.cloneDeep(state);

			/*  if (action.tab == 'adjustments') {
        jQuery('#btabs-alt-static-justified-adjustment').show();
      } else {
        jQuery('#btabs-alt-static-justified-adjustment').hide();
      } */

			console.log("LEAVE_TAB", action.tab);
			newState.leave.tab = action.tab;

			return newState;
		}
		case Types.LEAVE_UPDATING_BALANCES: {
			let newState = _.cloneDeep(state);
			newState.leave.leaveBalancesUpdating = true;
			return newState;
		}
		case Types.LEAVE_UPDATE_BALANCES: {
			let newState = _.cloneDeep(state);

			console.log("LEAVE_UPDATE_BALANCES", action.payload.leaveBalances);
			newState.leave.leaveBalances = action.payload.leaveBalances;
			newState.leave.leaveBalancesByType = action.payload.leaveBalancesByType;
			newState.leave.leaveBalancesUpdating = false;
			newState.leave.leaveBalance = action.payload.balance;
			// newState.leave.proRataLeave = action.payload.proRataLeave

			return newState;
		}
		case Types.LEAVE_UPDATING: {
			let newState = _.cloneDeep(state);

			// clear leave as it is now loading
			newState.leave.leaveUpdating = true;
			newState.leave.leave = [];

			return newState;
		}

		case Types.LEAVE_SET_FUTURE_BALANCE: {
			let newState = _.cloneDeep(state);
			newState.leave.futureLeaveBalance = action.status;

			return newState;
		}

		case Types.LEAVE_UPDATE: {
			let newState = _.cloneDeep(state);

			newState.leave.leave = action.leave;
			newState.leave.from = action.from;
			newState.leave.to = action.to;
			newState.leave.leaveUpdating = false;
			newState.leave.leaveUpdated = new Date();

			return newState;
		}
		case Types.LEAVE_UPDATING_MODAL: {
			let newState = _.cloneDeep(state);

			newState.leave.clashingLeaveUpdating = true;

			return newState;
		}

		case Types.LEAVE_UPDATE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.leave.clashingLeave = action.leave;
			newState.leave.clashingLeaveUpdating = false;

			return newState;
		}
		case Types.LEAVE_UPDATING_TIMELINE: {
			let newState = _.cloneDeep(state);

			newState.leave.timelineLeaveUpdating = true;

			return newState;
		}

		case Types.LEAVE_UPDATE_TIMELINE: {
			let newState = _.cloneDeep(state);

			newState.leave.timelineLeave = action.leave;
			newState.leave.timelineLeaveUpdating = false;

			return newState;
		}
		case Types.LEAVE_TYPES_UPDATING: {
			let newState = _.cloneDeep(state);

			newState.leave.leaveTypesUpdating = true;

			return newState;
		}

		case Types.LEAVE_TYPES_UPDATE: {
			let newState = _.cloneDeep(state);

			newState.leave.leaveTypes = action.leaveTypes;
			newState.leave.leaveTypesUpdating = false;

			if (newState.leave.leaveSettings) {
				const leaveTypes =
					newState.leave.leaveTypes &&
					newState.leave.leaveTypes.map((leaveType) => {
						const permissions =
							newState.leave &&
							newState.leave.leaveSettings &&
							newState.leave.leaveSettings.leaveTypes &&
							newState.leave.leaveSettings.leaveTypes.find((item) => item.id == leaveType.id);

						const resultingLeaveType = {
							...leaveType,
							...permissions,
						};

						return resultingLeaveType;
					});

				newState.leave.leaveTypes = leaveTypes;
			}

			return newState;
		}
		case Types.LEAVE_TYPES_PERMISSIONS: {
			let newState = _.cloneDeep(state);

			const { leaveType, permission } = action;

			console.log("leaveType", leaveType, permission);

			const index = newState.leave.leaveTypes.findIndex((item) => item.id == leaveType);

			newState.leave.leaveTypes[index][permission] = !newState.leave.leaveTypes[index][permission];

			return newState;
		}

		case Types.LEAVE_IMPORT_UPLOAD_TEMPLATE: {
			let newState = _.cloneDeep(state);
			newState.leaveImport.template = action.template;
			return newState;
		}
		case Types.LEAVE_IMPORT_SHOW_MODAL: {
			let newState = _.cloneDeep(state);
			newState.leaveImport.showModal = action.status;
			if (!action.status) newState.leaveImport = { results: {} };
			return newState;
		}
		case Types.LEAVE_FILE_UPLOADING: {
			let newState = _.cloneDeep(state);

			switch (action.uploadType) {
				case "LEAVE_MODAL":
					newState.leave.filesUploading = newState.leave.filesUploading
						? [...newState.leave.filesUploading, action.file]
						: [action.file];
					break;
				default:
					newState.leaveImport = {
						...newState.leaveImport,
						uploading: true,
					};
					break;
			}

			return newState;
		}
		case Types.LEAVE_FILE_UPLOADED: {
			let newState = _.cloneDeep(state);

			switch (action.uploadType) {
				case "LEAVE_MODAL":
					newState.leave.filesUploading = newState.leave.filesUploading.filter((name) => name != action.file);

					const fileDetails = { name: action.file, key: action.key };
					newState.leave.filesUploaded = newState.leave.filesUploaded
						? [...newState.leave.filesUploaded, fileDetails]
						: [fileDetails];

					NotificationManager.success(`${action.file} has been uploaded`, "Success");
					break;

				default:
					newState.leaveImport = {
						...newState.leaveImport,
						uploading: false,
						uploadResults: action.key,
					};
					break;
			}

			return newState;
		}
		case Types.LEAVE_IMPORT_DATA_PROCESSING: {
			let newState = _.cloneDeep(state);
			newState.leaveImport.processingFile = action.key;
			return newState;
		}
		case Types.LEAVE_IMPORT_DATA_PROCESSED: {
			let newState = _.cloneDeep(state);
			newState.leaveImport.results = {
				processed: action.processed,
				errors: action.errors,
				warnings: action.warnings,
			};
			newState.leaveImport.processingFile = null;
			return newState;
		}

		case Types.LEAVE_SETTINGS_UPDATING: {
			let newState = _.cloneDeep(state);

			newState.leave.leaveSettingsUpdating = true;

			return newState;
		}
		case Types.LEAVE_SETTINGS_UPDATE: {
			let newState = _.cloneDeep(state);

			newState.leave.leaveSettings = action.leaveSettings;
			const leaveTypes =
				newState.leave.leaveTypes?.map((leaveType) => {
					const permissions =
						action.leaveSettings &&
						action.leaveSettings.leaveTypes &&
						action.leaveSettings.leaveTypes.find((item) => item.id == leaveType.id);

					const resultingLeaveType = {
						...leaveType,
						...permissions,
					};

					return resultingLeaveType;
				}) || action.leaveSettings?.leaveTypes;

			newState.leave.leaveTypes = leaveTypes;
			newState.leave.lockDate = action.leaveSettings.lockDate && new Date(action.leaveSettings.lockDate);
			newState.leave.futureLockDate =
				action.leaveSettings.futureLockDate && new Date(action.leaveSettings.futureLockDate);
			newState.leave.leaveSettingsUpdating = false;

			const sickNotificationPeriods = action.leaveSettings.sickNotificationPeriods;

			newState.leave.leaveSettings.sickNotificationPeriods = [
				...(sickNotificationPeriods?.find((period) => period.id == "Default")
					? []
					: [{ id: "Default", name: "Default", period: 7 }]),
				...(sickNotificationPeriods || []),
			];

			return newState;
		}

		case Types.LEAVE_MULTI_OPTION_FIELD: {
			let newState = _.cloneDeep(state);
			const id = uuidv4();

			if (newState.leave.leaveSettings[action.field] == undefined) {
				newState.leave.leaveSettings[action.field] = [];
			}
			if (action.field == "leaveTypes") {
				newState.leave.leaveSettings[action.field] = [
					...newState.leave.leaveSettings[action.field],
					{ id, temporary: true },
				];
				newState.leave[action.field] = [...newState.leave[action.field], { id, temporary: true }];
			} else {
				newState.leave.leaveSettings[action.field] = [...newState.leave.leaveSettings[action.field], { id }];
			}

			return newState;
		}

		case Types.LEAVE_PERMISSIONS_UPDATING: {
			let newState = _.cloneDeep(state);

			newState.leave.leavePermissionsUpdating = true;

			return newState;
		}
		case Types.LEAVE_PERMISSIONS_UPDATE: {
			let newState = _.cloneDeep(state);

			// newState.leave.leaveTypes = action.leaveTypes;
			newState.leave.leavePermissionsUpdating = false;

			return newState;
		}
		case Types.LEAVE_LOCK_DATE: {
			let newState = _.cloneDeep(state);

			const { date } = action;

			newState.leave.lockDate = date;

			return newState;
		}
		case Types.LEAVE_FUTURE_LOCK_DATE: {
			let newState = _.cloneDeep(state);

			const { date } = action;

			newState.leave.futureLockDate = date;

			return newState;
		}

		// Start Leave Modal/Attachment/Comments
		case Types.LEAVE_ATTACHMENT_DOWNLOADING: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.leave.downloading = newState.leave.downloading || [];
			newState.leave.downloading.push(action.key);

			return newState;
		}

		case Types.LEAVE_ATTACHMENT_DOWNLOADED: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.leave.downloading = newState.leave.downloading.filter((key) => key != action.key);

			const popup = window.open(action.payload.signedURL);
			if (!popup || popup.closed || typeof popup.closed == "undefined") {
				//Worked For IE and Firefox
				alert("Popup Blocker is enabled! Please add this site to your exception list.");
			}

			return newState;
		}

		case Types.LEAVE_OPEN_MODAL: {
			let newState = _.cloneDeep(state);

			newState.leave.modalState = action.status;

			newState.leave.filesUploaded = null;

			if (!action.status) {
				delete newState.leave.modalStatus;
				newState.leave.modalLeave = {};
				return newState;
			}

			if (action.newEntry) {
				newState.leave.modalLeave = { ...action.leave, newEntry: true };
			} else {
				newState.leave.modalLeave = action.leave;
			}

			return newState;
		}
		case Types.LEAVE_BALANCE_REPORT_MODAL: {
			let newState = _.cloneDeep(state);

			newState.leave.balanceReportModal = action.status;

			return newState;
		}

		case Types.LEAVE_GENERATING_BALANCE_REPORT: {
			let newState = _.cloneDeep(state);

			newState.leave.generatingLeaveBalanceReport = action.status;

			return newState;
		}

		case Types.LEAVE_SHOW_CANCEL_LEAVE: {
			let newState = _.cloneDeep(state);

			newState.leave.showCancelLeave = action.leave;
			newState.leave.showCancelLeaveStatus = action.status;

			return newState;
		}

		case Types.LEAVE_SHOW_COMMENTS: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.leave.showComments = action.leave;

			return newState;
		}

		case Types.LEAVE_SHOW_ATTACHMENTS: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.leave.showAttachments = action.leave;

			return newState;
		}
		case Types.LEAVE_SAVING: {
			let newState = _.cloneDeep(state);

			if (!action.id) newState.leave.modalSaving = true;
			else {
				newState.leave.saving = { ...newState.leave.saving } || [];
				newState.leave.saving[action.id] = true;
			}

			return newState;
		}

		case Types.LEAVE_SAVE_CURRENT: {
			let newState = _.cloneDeep(state);

			const employeeList = newState.employees?.employeeListWithSalary || [];
			const currentDepartment = employeeList?.find(
				(item) => item.id == action.payload?.leave?.agreement,
			)?.department;
			const { leave } = { ...action.payload };

			if (currentDepartment) leave.department = currentDepartment;

			// TODO Action on add new ?? or update
			const myIndex =
				newState.leave &&
				newState.leave.leave &&
				newState.leave.leave &&
				newState.leave.leave.findIndex((item) => item.id == leave.id);
			if (myIndex >= 0) {
				newState.leave.leave[myIndex] = {
					...newState.leave.leave[myIndex],
					...leave,
					department: currentDepartment,
				};
			} else if (newState.leave && newState.leave.leave && newState.leave.leave) {
				console.log("addToMyLeave", leave);
				newState.leave.leave.push(leave);
				newState.leave.leave = _.orderBy(newState.leave.leave, ["start"], ["desc"]);
			}

			// clear files in case of uploads
			newState.leave.filesUploaded = [];

			// console.log('TIMESHEET_SAVED',action)
			newState.leave.modalSaving = false;

			newState.leave.saving = { ...newState.leave.saving };
			delete newState.leave.saving[leave.id];

			newState.leave.leaveSaved = true;
			newState.leave.modalState = false;
			newState.leave.modalTimesheet = null;

			NotificationManager.success(`Your Leave Application has been saved`, "Success");

			return newState;
		}
		case Types.LEAVE_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);
			if (action.fieldType) {
				newState.leave.leaveSettings[action.fieldType][
					newState.leave.leaveSettings[action.fieldType].findIndex((field) => field.id == action.id)
				][action.field] = action.newValue;
			} else {
				newState.leave.leaveSettings[action.field] = action.newValue;
			}

			if (action.fieldType == "leaveTypes") {
				newState.leave[action.fieldType][
					newState.leave[action.fieldType].findIndex((field) => field.id == action.id)
				][action.field] = action.newValue;
			}
			return newState;
		}
		case Types.LEAVE_MODAL_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);

			newState.leave.modalLeave = {
				...(newState.leave.modalLeave || {}),
				[action.field]: action.newValue,
			};

			if (newState.leave?.modalLeave?.date === newState.leave?.modalLeave?.dateTo) {
				newState.leave.modalLeave.hoursBreakdown = undefined;
			}

			return newState;
		}
		case Types.LEAVE_MODAL_UPDATE_BREAKDOWN: {
			let newState = _.cloneDeep(state);

			const hoursBreakdown = { ...(newState.leave.modalLeave.hoursBreakdown || {}) };

			hoursBreakdown[action.dateToUseString] = {
				...(hoursBreakdown[action.dateToUseString] || {}),
				...action.breakdownEntry,
			};

			newState.leave.modalLeave.hoursBreakdown = hoursBreakdown;

			return newState;
		}
		case Types.LEAVE_MODAL_CONTINUOUS: {
			let newState = _.cloneDeep(state);

			newState.leave.modalLeave.sickChainDate = action.date;

			return newState;
		}

		case Types.LEAVE_MODAL_MAP_BREAKDOWN: {
			let newState = _.cloneDeep(state);

			const { leaveBalance, modalLeave } = { ...newState.leave };
			const {
				date,
				dateTo,
				startTime,
				endTime,
				dateNotified,
				hoursBreakdown,
				type,
				sickChainDate,
				dateRevoked,
				id,
			} = { ...modalLeave };
			const {
				hoursPerShift,
				daysNotWorked,
				weeklyHours,
				notificationPeriod,
				hoursAvailable,
				halfPayBalance,
				isShiftWorker,
			} = newState.leave?.modalStatus?.employee || {};
			const { addPhToLeave } = { ...newState.leave?.leaveSettings };
			const { jurisdiction } = newState.company.settings;
			const { consumeBy, childDOB, entitledLatest, entitledTotal, revokeAfter, notifiedBefore, entitledPaid } = {
				...leaveBalance,
			};
			const leaveTypeSticker = newState.leave?.leaveTypes?.find((item) => item.id == type)?.stickerType?.[
				jurisdiction
			];

			const isSameDay = date == dateTo;
			if (!newState.leave?.modalStatus?.employee) return newState;
			if (isSameDay) {
				const inverted = startTime > endTime;

				const timeIn = parse(`${date} ${startTime}`, "yyyy-MM-dd HH:mm", new Date());
				const timeOut = addDays(parse(`${date} ${endTime}`, "yyyy-MM-dd HH:mm", new Date()), inverted ? 1 : 0);

				const hours = differenceInMinutes(timeOut, timeIn) / 60;
				newState.leave.modalLeave.hoursBreakdown = undefined;
				newState.leave.modalLeave.hours = hours;

				if (!hours) {
					newState.leave.modalLeave.hours = hoursPerShift;
					newState.leave.modalLeave.endTime = format(addHours(timeIn, hoursPerShift), "HH:mm");
				}

				return newState;
			}

			const weekStartsOn = jurisdiction == "UK" ? 0 : 1;
			const startDate = parse(date, "yyyy-MM-dd", new Date());
			const endDate = parse(dateTo, "yyyy-MM-dd", new Date());
			const notifiedDate = parse(dateNotified, "yyyy-MM-dd", new Date());

			const dateNotifiedBy = addDays(startDate, notificationPeriod);
			const effectiveFromDate =
				notifiedDate > dateNotifiedBy ? subDays(notifiedDate, notificationPeriod) : startDate;

			const firstDay = startOfWeek(startDate, { weekStartsOn });
			const lastWeekStartDate = startOfWeek(endDate, { weekStartsOn });
			const weeks =
				differenceInCalendarISOWeeks(lastWeekStartDate, firstDay) > 53
					? 52
					: differenceInCalendarISOWeeks(lastWeekStartDate, firstDay);
			const days = newState.leave.days;
			const holidays = newState.leave?.modalStatus?.holidays;

			let hoursToDate = 0;
			let fullPayConsumedDays = 0;
			// console.debug({ hoursBreakdown })

			const newHoursBreakdown = cleanDeep(
				[...Array(weeks + 1)]
					?.map((week, weekIndex) => {
						let hoursConsumed = 0;
						let hasEdited = false;
						return days?.map((day) => {
							const dayInPeriod = day + weekIndex * 7;
							const dateToUse = addDays(firstDay, dayInPeriod);
							const dateString = format(dateToUse, "yyyy-MM-dd");
							const isDayNotWorked = daysNotWorked?.includes(getDay(dateToUse));
							const outOfRange = dateToUse < startDate || endDate < dateToUse;
							const existing = hoursBreakdown?.[dateString];
							const isHoliday = holidays.includes(dateString) && !addPhToLeave && !isShiftWorker;
							let hours = id && !leaveBalance ? 0 : hoursPerShift;
							let sickType;
							let benefit;
							// console.debug(dateRevoked, dateString, dateRevoked <= dateString)
							if (dateRevoked <= dateString) return;
							if (isDayNotWorked || outOfRange) return;
							if (existing?.edited) {
								hours = parseFloat(existing.hours) || 0;
								hasEdited = true;
							}

							if (hoursConsumed + hoursPerShift > weeklyHours && hoursConsumed < weeklyHours)
								hours = id ? 0 : weeklyHours - hoursConsumed;
							//Sick
							if (type == 6022 && hours) {
								switch (jurisdiction) {
									case "UK":
										{
											sickType = "US";
											const differenceInDays = differenceInCalendarDays(
												dateToUse,
												effectiveFromDate,
											);

											if (differenceInDays < 3 && differenceInDays >= 0) sickType = "WD";
											if (differenceInDays >= 3) sickType = "SSP";
											if (sickChainDate) sickType = "SSP";
											if (hoursAvailable <= hoursToDate) sickType = "US";
										}
										break;

									case "MT":
										{
											const hasBalance = hoursToDate <= hoursAvailable;
											const hasHalfPayBalance =
												!hasBalance && hoursToDate - hoursAvailable <= halfPayBalance;
											const isUnpaid =
												!hasHalfPayBalance &&
												hoursToDate - hoursAvailable - halfPayBalance >= 0;

											if (hasBalance) sickType = "FP";
											if (hasHalfPayBalance) sickType = "HP";
											if (fullPayConsumedDays >= 3) benefit = "SB";
											fullPayConsumedDays++;
											if (isUnpaid) sickType = "US";
											if (isUnpaid || isHoliday) {
												fullPayConsumedDays--;
											}
											// const isHalfPay = halfPayBalance > (hoursToDate - hoursAvailable)
											// sickType = 'FP'

											// // console.debug({ hoursBalance: hoursToDate - hoursAvailable, hoursToDate, hoursAvailable })
											// if (fullPayConsumedDays >= 3) benefit = 'SB'
											// if (hoursToDate >= hoursAvailable) sickType = 'HP'
											// if (isUnpaid) sickType = 'US'
										}
										break;
								}
							} else if (leaveTypeSticker) {
								if (dateString > entitledPaid) {
									sickType = "UP";
								} else if ((notifiedBefore ? dateNotified : true) && dateNotified > notifiedBefore) {
									sickType = "UP";
								} else {
									sickType = leaveTypeSticker;
								}
							}
							//specific leave types )
							if (["6020"].includes(String(type)) && isHoliday) return;
							if (!["WD", "US"]?.includes(sickType)) hoursToDate += hours;

							if (existing?.edited) {
								hoursConsumed += hours;
								return {
									...existing,
									edited: true,
									isPaid: !!existing?.isPaid,
									id: existing?.id,
									hoursToDate,
									sickType: hours ? sickType : undefined,
									editedSickType: hours ? existing?.editedSickType : undefined,
									benefit: hours && existing?.sickType != "US" ? existing?.benefit : undefined,
									dateString,
								};
							}

							if (hoursConsumed >= weeklyHours) return;
							hoursConsumed += hours;

							return {
								dateString,
								hours,
								isPaid: !!existing?.isPaid,
								edited: hasEdited ? !!hasEdited : undefined,
								sickType: hours ? sickType : undefined,
								benefit: hours && sickType != "US" ? benefit : undefined,
								hoursToDate,
							};
						});
					})
					.flat(1),
			);

			// console.debug(leaveBalance)

			if (leaveBalance) {
				if (!(notifiedBefore && dateNotified) || !date || !dateTo) {
					newState.leave.modalLeave.weeklyBreakdown = undefined;
				} else {
					const weeklyBreakdown = cleanDeep(
						[...Array(weeks + 1)]?.map((week, weekIndex) => {
							const dateFrom = addDays(firstDay, weekIndex * 7);
							const dateFromString = format(dateFrom, "yyyy-MM-dd");
							if (dateFromString > dateRevoked) return;
							const dateTo = addDays(firstDay, weekIndex * 7 + 6);

							if (dateFromString > entitledPaid) {
								// console.debug(dateFromString, 'afterPaid')
								return "UP";
							}
							if ((notifiedBefore ? dateNotified : true) && dateNotified > notifiedBefore) {
								// console.debug(dateFromString, 'notified late')
								return "UP";
							}
							// console.debug(dateFromString, leaveTypeSticker)
							return leaveTypeSticker;
						}),
					);
					newState.leave.modalLeave.weeklyBreakdown = weeklyBreakdown;
				}
			}

			newState.leave.modalLeave.hoursBreakdown = newHoursBreakdown.reduce(
				(a, v) => ({
					...a,
					[v.dateString]: { ...v, dateString: undefined },
				}),
				{},
			);
			newState.leave.modalLeave.sickType = undefined;
			newState.leave.modalLeave.editedSickType = undefined;
			newState.leave.modalLeave.hours = newHoursBreakdown.reduce((a, v) => a + (parseFloat(v.hours) || 0), 0);

			return newState;
		}

		case Types.LEAVE_UPDATE_MODAL_STATUS: {
			let newState = _.cloneDeep(state);

			const leave = action.leave || newState.leave.modalLeave;
			// ! LOAD ESSENTIAL EMPLOYEE DETAILS
			const agreement = leave?.agreement;
			const leaveType = leave?.type;
			const employeeSalary = newState.employees?.employeeListWithSalary?.find(
				(employee) => employee.id == agreement,
			);
			const salary = employeeSalary?.salaries?.[employeeSalary?.salaries?.length - 1];
			const days = newState.leave?.days;
			const workingDays = salary?.workingDays?.filter(Boolean);
			const weeklyHours = parseFloat(salary?.weeklyHours);
			const hoursPerShift = workingDays?.length && weeklyHours && weeklyHours / parseFloat(workingDays?.length);
			const daysNotWorked = days?.filter(
				(day) => !(workingDays?.map((d) => Number(d) - 1) || days).includes(day),
			);
			const maxDailyLeaveHours = parseFloat(newState.leave?.leaveSettings?.maxDailyLeaveHours) || 0;
			const leaveBalance =
				action.balances[leaveType] ||
				newState.leave.leaveBalancesByType?.[leaveType]?.find((item) => agreement == item.agreementId);
			const holidays = action.holidays;

			// ! LOAD PAID LEAVE INFORMATION
			const hoursBreakdown = newState.leave?.modalLeave?.hoursBreakdown;
			const lastPaidDate =
				hoursBreakdown &&
				_.orderBy(
					Object.keys(hoursBreakdown)?.map((item) => ({
						date: item,
						isPaid: hoursBreakdown?.[item]?.isPaid,
					})),
					["date"],
					["desc"],
				)?.find((item) => !!item.isPaid)?.date;
			const isPaid =
				newState.leave?.modalLeave?.isPaid ||
				(hoursBreakdown &&
					Object.keys(hoursBreakdown)?.length > 0 &&
					!_.find(hoursBreakdown, { isPaid: false }));

			const employeeDepartment = employeeSalary?.department;
			const sickNotificationPeriods = newState.leave?.leaveSettings?.sickNotificationPeriods;

			const casual = salary?.casual;
			const isShiftWorker = casual ? true : !workingDays || workingDays?.length == 0;

			newState.leave.modalStatus = {
				employee: {
					engagementDate: employeeSalary?.engagementDate,
					terminationDate: employeeSalary?.terminationDate,
					weeklyHours: weeklyHours || 40,
					workingDays,
					hourlySalary: salary?.hourlySalaryAmount,
					weeklySalary: salary?.weeklySalary,
					employee: employeeSalary?.employee,
					casual,
					isShiftWorker,
					hoursPerShift: maxDailyLeaveHours ? maxDailyLeaveHours : hoursPerShift || 8,
					daysNotWorked: daysNotWorked?.length === 7 ? [] : daysNotWorked,
					hoursAvailable: parseFloat(leaveBalance?.balanceThisYearWithFutureLeave) || 0,
					hoursPending: parseFloat(leaveBalance?.hoursPending) || 0,
					halfPayBalance: parseFloat(leaveBalance?.halfPayBalance - leaveBalance?.halfPayConsumed) || 0,
					notificationPeriod:
						parseFloat(
							sickNotificationPeriods?.find((period) => period.department == employeeDepartment)
								?.period || sickNotificationPeriods?.find((period) => period.id == "Default")?.period,
						) || 7,
				},
				status: {
					lastPaidDate: isPaid && !lastPaidDate ? newState.leave?.modalLeave?.dateTo : lastPaidDate,
					isPaid,
				},
				holidays,
			};

			return newState;
		}
		case Types.LEAVE_MODAL_DETAILS_LOADING: {
			let newState = _.cloneDeep(state);

			newState.leave.modalDetailsLoading = action.status ? action.status : false;

			return newState;
		}
		case Types.LEAVE_UPDATE_MODAL_DETAILS: {
			let newState = _.cloneDeep(state);

			Object.entries({ ...action.details }).map(([key, value]) => {
				newState.leave.modalLeave[key] = value;
			});

			return newState;
		}
		case Types.LEAVE_GET_RULES: {
			let newState = _.cloneDeep(state);

			newState.leave.rules = action.rules;

			return newState;
		}
		case Types.LEAVE_SAVE_RULES: {
			let newState = _.cloneDeep(state);

			// make sure the order of the rules is the same as the order of the rules in the existing state
			const newRules = action?.rules?.map((rule) => {
				const existingRule = newState.leave.rules.find((r) => r.id == rule.id);
				return existingRule ? { ...existingRule, ...rule } : rule;
			});

			newState.leave.rules = newRules;

			return newState;
		}
		case Types.LEAVE_UPDATE_RULE: {
			let newState = _.cloneDeep(state);

			const { id, field, value, action: fieldAction } = action.data;

			const ruleIndex = newState.leave.rules.findIndex((rule) => rule.id == id);
			const rule = { ...newState.leave.rules[ruleIndex] };

			set(rule, field, value);

			// assume the field is applyTo.1 where 1 is the array index
			// if value is null, and this is an array, remove the item
			if (fieldAction === "remove" && field.match(/\.\d+$/)) {
				const [originalField, index] = field.split(".");
				rule[originalField].splice(index, 1);
			}

			rule.dirty = true;

			newState.leave.rules[ruleIndex] = rule;

			return newState;
		}
		case Types.LEAVE_ADD_RULE: {
			let newState = _.cloneDeep(state);

			newState.leave.rules = newState.leave.rules || [];
			newState.leave.rules.push({
				id: uuidv4(),
				applyTo: [
					{
						when: "all",
					},
				],
				entitlements: [{}],
			});

			return newState;
		}
		case Types.LEAVE_SAVE_MARKED: {
			let newState = _.cloneDeep(state);

			newState.leave.markedLeave = { ...newState.leave?.markedModal, markedLeave: action.data };

			return newState;
		}
		case Types.LEAVE_SET_MARKED_MODAL: {
			let newState = _.cloneDeep(state);

			newState.leave.markedModal = { ...newState.leave?.markedModal, open: action.status };

			return newState;
		}
		default:
			return state;
	}
};

export default leaveReducers;
